"use strict";

require("core-js/modules/es.object.define-property.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TenantStatus = exports.Month = void 0;
var TenantStatus = exports.TenantStatus = /*#__PURE__*/function (TenantStatus) {
  TenantStatus["MOVE_IN"] = "Moving in";
  TenantStatus["MOVE_OUT"] = "Moving out";
  return TenantStatus;
}({});
var Month = exports.Month = /*#__PURE__*/function (Month) {
  Month["JANUARY"] = "January";
  Month["FEBRUARY"] = "February";
  Month["MARCH"] = "March";
  Month["APRIL"] = "April";
  Month["MAY"] = "May";
  Month["JUNE"] = "June";
  Month["JULY"] = "July";
  Month["AUGUST"] = "August";
  Month["SEPTEMBER"] = "September";
  Month["OCTOBER"] = "October";
  Month["NOVEMBER"] = "November";
  Month["DECEMBER"] = "December";
  return Month;
}({});